// extracted by mini-css-extract-plugin
module.exports = {"container":"sWhz9X1A0N5AKgEfuuZzT","loader":"_1uJYR-Cp6wT4FVz98LJJEN","disabled":"_33yCyuDEMtYRnsKExUVFM4","label":"_3MxfWX5vF-4I3uAzAs0S9c","icon":"_1KUEbyqpFPU18t_Nb0Mh39"};